import { DefaultRole } from 'app/area/administration/shared/types';

export const compareDefaultRole = (
  markedAsDefaultRole: boolean,
  id: number,
  currentDefaultRole: DefaultRole
): boolean => {

  const isDefaultRole = !!currentDefaultRole && currentDefaultRole?.value === id;

  return (markedAsDefaultRole ?? false) !== isDefaultRole;
};
